import { useQuery } from '@tanstack/react-query';
import type { Bootstrap } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { api_account_bootstrap_data_path } from '@/utils/routes';

export const useBootstrapData = (enabled = true) => {
  const req = useQuery<Bootstrap>({
    queryKey: [clientKeys.useBootstrapData],
    queryFn: () => falconClient.get(api_account_bootstrap_data_path()),
    enabled,
  });

  return { bootstrap: req?.data, ...req };
};
